<div>
	<p-table
		#mydt
		[value]="lstVisitee"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitee"
		dataKey="ID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--VisiteeName-->
				<th>
					<p-columnFilter type="text" field="VisiteeName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--VisitCount-->
				<th>
					<!-- <p-columnFilter type="text" field="VisitCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="VisiteeName">Name<p-sortIcon field="VisiteeName"></p-sortIcon></th>
				<th pSortableColumn="VisitCount">Count<p-sortIcon field="VisitCount"></p-sortIcon></th>
				<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Visitee>
			<tr [pSelectableRow]="Visitee">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Visitee[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
